export const styleText = {
   fontFamily:'',
   letterSpacing: '.0rem',
   textDecoration: 'none',
}